import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['remove', 'template', 'addEntryContainer']
  static values = { autoAdd: Boolean }

  // this.element is the #n-group-... div
  connect() {
    this.update_arrows();
    if (this.autoAddValue) this.add()
  }

  // One of the links will be the template
  add() {
    var new_index = 0;

    // Get the highest index of the counter
    this.element.querySelectorAll('.counter').forEach(item => {
      const counter_value = Number(item.value)
      if (!isNaN(counter_value)) {
        new_index = (counter_value >= new_index) ? (counter_value + 1) : new_index;
      }
    })

    const content = this.templateTarget.innerHTML
      .replace(/NEW_RECORD/ig, new_index)
      .replace(/data-controller="move-up-down"/g, 'data-controller="move-up-down extended-form-controls"')
    this.addEntryContainerTarget.insertAdjacentHTML('beforebegin', content);

    this.update_arrows()
  }

  update_arrows() {
    var entries = this.element.querySelectorAll('.field-group-entry');

    entries.forEach((item, index) => {
      item.querySelectorAll('button.move-up').forEach(button => {
        button.disabled = (index == 0)
      })
      item.querySelectorAll('button.move-down').forEach(button => {
        button.disabled = (index == (entries.length - 1))
      })
    });
  }
}
